import { register } from "@shared/services/propertyRendererRegistry";
import StatusTagRenderer from "@shared/components/tickets/components/StatusTagRenderer.vue";
import { dataQualityTicketType } from "./constants";

register({
  twinTypePattern: dataQualityTicketType,
  customId: "status",
  viewComponentTable: StatusTagRenderer,
  viewComponentDetail: StatusTagRenderer,
});
